import { AddressPoint } from '@/entities/address/model/use-address-store';
import { Flex, HStack, IconButton, Text } from '@chakra-ui/react';
import { LuMapPin, LuTrash2 } from 'react-icons/lu';

type Props = {
  onDelete: (id: string) => void;
  address: AddressPoint;
};

const AddressItem: React.FC<Props> = ({ onDelete, address }) => {
  return (
    <Flex
      alignItems="center"
      justifyContent="space-between"
      py="2"
      borderBottom="1px solid"
      borderBottomColor="gray.200"
    >
      <HStack>
        <LuMapPin size="24" color="var(--text-muted)" />
        <Text color="var(--text-muted)" lineClamp="2">
          {address.address}
        </Text>
      </HStack>

      <IconButton
        size="xl"
        variant="ghost"
        color="var(--text-muted)"
        onClick={() => onDelete(address.id)}
      >
        <LuTrash2 size="20" />
      </IconButton>
    </Flex>
  );
};

export default AddressItem;
